/**
 * Converte phisicalAddress para URL pública acessível
 * Replica a lógica do backend: PhisicalAddress.Replace("C:\\T2B\\ProductImages", baseUrl).Replace("\\", "/")
 */
export function getPublicImageUrl(phisicalAddress: string | null, baseUrl?: string): string | null {
  if (!phisicalAddress) {
    return null;
  }

  const apiBaseUrl = baseUrl || import.meta.env.VITE_API_URL || "https://api-qas.talk2buy.com.br";
  
  // Replicar exatamente a lógica do backend C#:
  // image.PublicUrl = image.PhisicalAddress
  //   .Replace("C:\\T2B\\ProductImages", "https://api-qas.talk2buy.com.br/images")
  //   .Replace("\\", "/");
  
  const publicUrl = phisicalAddress
    .replace(/C:\\T2B\\ProductImages/gi, `${apiBaseUrl}/images`)
    .replace(/\\/g, "/");
  
  return publicUrl;
}
